module.exports = __webpack_public_path__ + "static/img/login_bg.b91973ae.png";